import { DateTime } from "luxon"
import { displayMessage } from "../../../services/helper"
import EDaysOfTheWeek from "../../../enums/EDaysOfTheWeek"



export default
    [
        {
            field: 'name',
            headerName: displayMessage('NAME'),
            // headerAlign: 'center',
            // width: 300,
            flex: 1,
            valueGetter: function (params) {
                return `${params.row?.name}`
            }
        },
        {
            field: 'description',
            headerName: displayMessage('DESCRIPTION'),
            // headerAlign: 'center',
            // width: 300,
            flex: 1,
            valueGetter: function (params) {
                return `${params.row?.description}`
            }
        },
        {
            field: 'scheduleDays',
            headerName: displayMessage('SCHEDULE_DAYS'),
            width:600,
            valueGetter: (params) => {
                const scheduledDays = params.row?.scheduleDays || [];
              
                const days = scheduledDays
                  .sort((a, b) => a - b)
                  .map((dayNumber) => {
                    const day = Object.values(EDaysOfTheWeek).find(d => d.code === dayNumber);
                    return day?.label;
                  });
              
                return days.join(', ');
              }
        }
        // {
        //     field: 'holiday_date',
        //     headerName: displayMessage('DATE'),
        //     // width: 150,
        //     flex: 1,
        //     headerAlign: 'center',
        //     sortable: false,
        //     align: 'center',
        //     valueFormatter: (params) => {
        //         if (!params?.value) {
        //             return ''
        //         }
        //         const data = DateTime.fromISO(params.value).toUTC(); //.startOf('day').toUTC();
        //         return data.toFormat('dd/MM/yyyy')
        //     }
        // }
    ]